"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Deferred_1 = __importDefault(require("./classes/Deferred"));
exports.default = Deferred_1.default;
//# sourceMappingURL=index.js.map